<template>
    <modal v-if="showModal" class="account-modal" @close="actionHideModal">
        <template slot="header">
            <div class="modal-title-container">
                <h4 class="modal-title">{{$t('Do you want to delete')}} {{name}}?</h4>
                <div class="icon-container">
                    <md-icon @click.native="actionHideModal">clear</md-icon>
                </div>
            </div>
        </template>
        <template slot="body">
        </template>
        <template slot="footer">
            <md-button class="md-simple" @click="actionHideModal">{{$t('Cancel')}}</md-button>
            <md-button class="md-primary" @click="actionDelete">{{$t('Delete')}}</md-button>
        </template>
    </modal>
</template>

<script>
    import Modal from "../components/Modal";

    export default {
        name: "DeletePromptModal",
        props: {
            name: {
                type: String
            },
            showModal: {
                type: Boolean,
                required: true,
            }
        },
        components: {Modal},
        methods: {
            actionHideModal() {
                this.$emit('cancel');
            },
            actionDelete() {
                this.$emit('confirmation');
            },
        },
    }
</script>

<style lang="scss">
    .account-modal {
        .modal-header {
            flex-direction: column;
            align-items: flex-start;

            .modal-title-container {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }

            .icon-container {
                .md-icon {
                    opacity: .5;
                    font-size: 16px !important;
                    cursor: pointer;

                    &:hover {
                        opacity: 1;
                    }
                }
            }
        }

        .modal-footer {
            .md-button {
                height: 41px !important;
                width: auto !important;
            }
            & > * {
                margin-left: 12px !important;
            }
        }

        .modal-header, .modal-body, .modal-footer {
            width: 500px;
        }

        .md-table-cell {
            padding: 0;
        }
    }
</style>